import { UseCustomAxios } from "../../UseCustomAxios";
import { useSnackbar } from "notistack";
import { isEmpty } from "../../util/Utils";

export function UseReminder() {
  const MyAxios = UseCustomAxios();
  const { enqueueSnackbar } = useSnackbar();

  const AvailableProducts = (myPC, search, bool, callback) => {
    MyAxios.get(`Admin_Reminder?w=${search}`, {
      headers: {
        IsPage: bool ? true : false,
        Conditions: JSON.stringify({ pageCondition: myPC }),
        Stoke: true,
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const UnavailableProducts = (myPC, search, bool, callback) => {
    MyAxios.get(`Admin_Reminder?w=${search}`, {
      headers: {
        IsPage: bool ? true : false,
        Conditions: JSON.stringify({ pageCondition: myPC }),
        Stoke: false,
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const GetCustomersList = (productId, callback) => {
    MyAxios.get(`Admin_Reminder/${productId}`).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const SendReminderSMS = (ProductID, callback) => {
    const data = new FormData();
    data.append("ProductID", ProductID);
    MyAxios.post(`Admin_Reminder`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("باموفقیت ارسال شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback(response.data.resault);
      }
    });
  };

  return {
    AvailableProducts,
    UnavailableProducts,
    GetCustomersList,
    SendReminderSMS,
  };
}
